import Service from "../../services";

const Meeting = {
  namespaced: true,
  state: {},
  mutations: {},
  actions: {
    getMeetingList({ commit }, page) {
      return Service.Meeting.getMeetingList(page)
        .then((res) => {
          return res;
        })
        .catch((err) => {
          return Promise.reject(err);
        });
    },
    getAllMeetingList({ commit }, page) {
      return Service.Meeting.getAllMeetingList(page)
        .then((res) => {
          return res;
        })
        .catch((err) => {
          return Promise.reject(err);
        });
    },
    getSubMeetingList({ commit }, page) {
      return Service.Meeting.getSubMeetingList(page)
        .then((res) => {
          return res;
        })
        .catch((err) => {
          return Promise.reject(err);
        });
    },
    save({ commit }, data) {
      return Service.Meeting.save(data)
        .then((res) => {
          return res;
        })
        .catch((err) => {
          return Promise.reject(err);
        });
    },
    reviewSave({ commit }, data) {
      return Service.Meeting.reviewSave(data)
        .then((res) => {
          return res;
        })
        .catch((err) => {
          return Promise.reject(err);
        });
    },
    saveSubMeeting({ commit }, data) {
      return Service.Meeting.saveSubMeeting(data)
        .then((res) => {
          return res;
        })
        .catch((err) => {
          return Promise.reject(err);
        });
    },
    delete({ commit }, id) {
      return Service.Meeting.delete(id)
        .then((res) => {
          return res;
        })
        .catch((err) => {
          return Promise.reject(err);
        });
    },
    update({ commit }, data) {
      return Service.Meeting.update(data, data.id)
        .then((res) => {
          return res;
        })
        .catch((err) => {
          return Promise.reject(err);
        });
    },
    updateSubMeet({ commit }, data) {
      console.log(data);
      return Service.Meeting.updateSubMeet(data, data.id)
        .then((res) => {
          return res;
        })
        .catch((err) => {
          return Promise.reject(err);
        });
    },
    getMeet({ commit }, id) {
      return Service.Meeting.getMeeting(id)
        .then((res) => {
          return res;
        })
        .catch((err) => {
          return Promise.reject(err);
        });
    },
    getSubMeet({ commit }, id) {
      return Service.Meeting.getSubMeet(id)
        .then((res) => {
          return res;
        })
        .catch((err) => {
          return Promise.reject(err);
        });
    },
    getSubMeetForView({ commit }, id) {
      return Service.Meeting.getSubMeetForView(id)
        .then((res) => {
          return res;
        })
        .catch((err) => {
          return Promise.reject(err);
        });
    },
    getMeetForView({ commit }, id) {
      return Service.Meeting.getMeetForView(id)
        .then((res) => {
          return res;
        })
        .catch((err) => {
          return Promise.reject(err);
        });
    },
    filterMeeting({ commit }, data) {
      return Service.Meeting.filterMeeting(data)
        .then((res) => {
          return res;
        })
        .catch((err) => {
          return Promise.reject(err);
        });
    },
    filterSubMeeting({ commit }, data) {
      return Service.Meeting.filterSubMeeting(data)
        .then((res) => {
          return res;
        })
        .catch((err) => {
          return Promise.reject(err);
        });
    },
    getAllMeetingAttendees({ commit }, data) {
      return Service.Meeting.getAllMeetingAttendees(data)
        .then((res) => {
          return res;
        })
        .catch((err) => {
          return Promise.reject(err);
        });
    },
    getMeetingAttendees({ commit }, data) {
      return Service.Meeting.getMeetingAttendees(data)
        .then((res) => {
          return res;
        })
        .catch((err) => {
          return Promise.reject(err);
        });
    },
    getSearchMeetingAttendees({ commit }, data) {
      return Service.Meeting.getSearchMeetingAttendees(data)
        .then((res) => {
          return res;
        })
        .catch((err) => {
          return Promise.reject(err);
        });
    },
    getMeetList({ commit }) {
      return Service.Meeting.getMeetList()
        .then((res) => {
          return res;
        })
        .catch((err) => {
          return Promise.reject(err);
        });
    },
    getSubMeetList({ commit }) {
      return Service.Meeting.getSubMeetList()
        .then((res) => {
          return res;
        })
        .catch((err) => {
          return Promise.reject(err);
        });
    },
    searchMeetingAttendees({ commit }, data) {
      return Service.Meeting.searchMeetingAttendees(data)
        .then((res) => {
          return res;
        })
        .catch((err) => {
          return Promise.reject(err);
        });
    },
    getJoinMeeting({ commit }, id) {
      return Service.Meeting.getJoinMeeting(id)
        .then((res) => {
          return res;
        })
        .catch((err) => {
          return Promise.reject(err);
        });
    },
    getCurrentMeetingSelect({ commit }) {
      return Service.Meeting.getCurrentMeetingSelect()
        .then((res) => {
          return res;
        })
        .catch((err) => {
          return Promise.reject(err);
        });
    },
    updateStatusMeeting({ commit }, data) {
      return Service.Meeting.updateStatusMeeting(data)
        .then((res) => {
          return res;
        })
        .catch((err) => {
          return Promise.reject(err);
        });
    },
    getAllMeeting({ commit }, page) {
      return Service.Meeting.getAllMeeting(page)
        .then((res) => {
          return res;
        })
        .catch((err) => {
          return Promise.reject(err);
        });
    },
  },
};

export default Meeting;
